<script lang="ts">
import type { LoginFormType } from '../../CustomerNavigation1XP.vue';
import FormInput from '../../../FormInput/FormInput.vue';
import Button1XP from '../../../Button1XP/Button1XP.vue';
import { ref } from 'vue';
import { useStoreTranslations } from '../../../../store/translations/translations';

type Props = {
  loginForm: LoginFormType;
};

const emailRef = ref<string>();
const passRef = ref<string>();
</script>

<script setup lang="ts">
defineProps<Props>();

const emit = defineEmits(['login']);

const storeTranslations = useStoreTranslations();
</script>

<template>
  <div :class="$style.container">
    <form @submit.prevent="() => emit('login', { email: emailRef, password: passRef })">
      <FormInput
        v-model="emailRef"
        :aria-label="storeTranslations.translations?.['loginForm.emailPlaceholder']"
        :aria-required="true"
        :label="storeTranslations.translations?.['loginForm.emailPlaceholder']"
        :placeholder="storeTranslations.translations?.['loginForm.emailPlaceholder']"
        required
        type="email"
      />
      <FormInput
        v-model="passRef"
        :aria-label="storeTranslations.translations?.['loginForm.passwordPlaceholder']"
        :aria-required="true"
        :label="storeTranslations.translations?.['loginForm.passwordPlaceholder']"
        :placeholder="storeTranslations.translations?.['loginForm.passwordPlaceholder']"
        required
        type="password"
      />
      <div :class="$style.actions">
        <Button1XP
          :class="$style.fullWidth"
          :is-disabled="!emailRef || !passRef"
          :text="storeTranslations.translations?.['loginForm.formTitle']"
          variant="primary"
          @click="
            () => emailRef && passRef && emit('login', { email: emailRef, password: passRef })
          "
        />
        <Button1XP
          size="s"
          :text="storeTranslations.translations?.['loginForm.forgottenPassword']"
          :url="loginForm.iFramePage + loginForm.forgotPasswordAction"
          variant="linkStatic"
        />
        <Button1XP
          :class="$style.fullWidth"
          :text="storeTranslations.translations?.['loginForm.register']"
          :url="loginForm.iFramePage + loginForm.registrationAction"
          variant="secondary"
        />
        <input
          :aria-label="storeTranslations.translations?.['loginForm.formTitle']"
          hidden
          type="submit"
        />
      </div>
    </form>
  </div>
</template>
<style lang="scss" module src="./LoginForm.scss" />
